import AnimatedBlobImage from '@atoms/AnimatedBlobImage/AnimatedBlobImage';
import Button from '@atoms/Button/Button';
import {
  HeroLifelines,
  SecondaryLifeline,
} from '@atoms/HeroLifelines/HeroLifelines';
import RichText from '@atoms/RichText/RichText';
import { matchmakerType } from '@lib/proptypes';
import { useSortedFilters } from '@utils';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

import styles from './Matchmaker.module.scss';
import Question1 from './Question1';
import Question2 from './Question2';
import Question3 from './Question3';
import Question4 from './Question4';
import Question5 from './Question5';
import Question6 from './Question6';
import Question7 from './Question7';

const questions = {
  1: Question1,
  2: Question2,
  3: Question3,
  4: Question4,
  5: Question5,
  6: Question6,
  7: Question7,
};

function MatchmakerSteps({
  page: { title, subtitle, introText, cta, filters },
  step,
}) {
  const router = useRouter();

  const handleNavigation = (event, parameters) => {
    event.preventDefault();
    const href = event.currentTarget.getAttribute('href');

    router.push(
      {
        pathname: href,
        query: parameters,
      },
      undefined,
      { shallow: true }
    );
  };

  const sortedFilters = useSortedFilters(filters);

  const Question = questions[step];

  useEffect(() => {
    if (!Question) return;

    window.dataLayer.push({
      event: 'matchmakerStepView',
      matchmakerStep: step,
    });
  }, [Question, step]);

  if (Question) {
    return (
      <Question filters={sortedFilters} handleNavigation={handleNavigation} />
    );
  }

  return (
    <>
      <h1 className={styles.title}>{title}</h1>
      {!!subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      {!!introText && <RichText text={introText} className={styles.text} />}
      <Button
        extraClasses={styles.cta}
        label={cta}
        href="/matchmaker/1"
        onClick={handleNavigation}
      />
    </>
  );
}

function Matchmaker(props) {
  const { query } = useRouter();
  const [slug] = query.slug || [0];
  const [step, setStep] = useState(Number(slug));

  const image = useMemo(() => {
    if (!step) {
      // eslint-disable-next-line react/destructuring-assignment
      return props.image;
    }

    // eslint-disable-next-line react/destructuring-assignment
    if (props[`imageQuestion${step}`]) {
      // eslint-disable-next-line react/destructuring-assignment
      return props[`imageQuestion${step}`];
    }

    // eslint-disable-next-line react/destructuring-assignment
    return props.image;
  }, [step, props]);

  useEffect(() => {
    const [value] = query.slug || [0];
    setStep(Number(value));
  }, [query.slug]);

  return (
    <section className={styles.matchmaker}>
      <HeroLifelines />

      <div className={classNames('u-container', styles.container)}>
        <SecondaryLifeline />

        <div className={styles.content}>
          <MatchmakerSteps page={props} step={step} />
        </div>

        <div className={styles.imageContainer}>
          <AnimatedBlobImage image={image} />
        </div>
      </div>
    </section>
  );
}
MatchmakerSteps.propTypes = {
  page: matchmakerType,
  step: PropTypes.number.isRequired,
};

Matchmaker.propTypes = matchmakerType;

export default Matchmaker;
